import { scrollTracker } from "./utilities/scrollTracker"
import { masthead } from "./blocks/masthead"
import { people } from "./blocks/people"
import { netAssetValue } from "./blocks/netAssetValue"
import { secFilings } from "./blocks/secFilings"
import { choicesJS } from "./utilities/choices"

document.addEventListener("DOMContentLoaded", () => {
  scrollTracker();
  masthead();
  people();
  netAssetValue();
  secFilings();
  choicesJS();
});


